import { combineReducers } from 'redux-immutable';
import * as types from './types';
import { StateValue } from './models';
import currency from '../utils';

const calculate = (payload) => {
  const device = payload.device>100000 ? 100000 : payload.device;
  const updateSize = payload.updateSize>5000 ? 5000 : payload.updateSize;
  const rollout = payload.rollout>5 ? 5 : payload.rollout;
  const percentualDevice = payload.percentualDevice>100 ? 100 : payload.percentualDevice;

  let log = -0.99*Math.log10(device)+6.2;
  log = device>0 ? log : 0;
  const deviceFee = log*0.04166;
  const devicePrice = currency(deviceFee*device);
  const activationFee = deviceFee*8.5;
  const activationPrice = currency(activationFee*device);
  const storagePerGb = Math.ceil(updateSize/1000);
  const storagePrice = currency(storagePerGb*0.05);
  const rolloutFee = deviceFee*1.33367;
  const deviceUpdate = device*percentualDevice/100;
  const rolloutPrice = currency(rolloutFee*deviceUpdate*rollout);
  const updatePerGb = updateSize/1000;
  const updateTotal = deviceUpdate*rollout*updatePerGb;
  const transferFee = storagePerGb*0.095;
  const transferPrice= currency(transferFee*updateTotal);
  return{ device, updateSize, rollout, percentualDevice, devicePrice, activationPrice, storagePrice, rolloutPrice, transferPrice };
};

export const stateValue = (state = StateValue(), action) => {
  switch (action.type) {
    case types.SET_VALUE: {
      const results = calculate(action.payload);
      return state.setIn(['device'], results.device)
                  .setIn(['devicePrice'], results.devicePrice)
                  .setIn(['activationPrice'], results.activationPrice)
                  .setIn(['updateSize'], results.updateSize)
                  .setIn(['storagePrice'], results.storagePrice)
                  .setIn(['rollout'], results.rollout)
                  .setIn(['rolloutPrice'], results.rolloutPrice)
                  .setIn(['percentualDevice'], results.percentualDevice)
                  .setIn(['transferPrice'], results.transferPrice);
    }
    case types.GET_VALUE:
      return StateValue();
    default:
      return state;
  }
};

export default combineReducers({
  stateValue,
});

export const getValue = state =>
  state.getIn(['value', 'stateValue']);
